module.exports = __webpack_public_path__ + "static/media/red_moto.0123f233.png";